'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.padScaleModifiers = exports.displayModifiers = exports.dimensionModifiers = undefined;

var _templateObject = _taggedTemplateLiteral(['\n      display: flex;\n    '], ['\n      display: flex;\n    ']),
    _templateObject2 = _taggedTemplateLiteral(['\n      height: 100%;\n    '], ['\n      height: 100%;\n    ']),
    _templateObject3 = _taggedTemplateLiteral(['\n      flex: 1;\n    '], ['\n      flex: 1;\n    ']),
    _templateObject4 = _taggedTemplateLiteral(['\n      display: none;\n    '], ['\n      display: none;\n    ']),
    _templateObject5 = _taggedTemplateLiteral(['\n      padding: 0;\n    '], ['\n      padding: 0;\n    ']),
    _templateObject6 = _taggedTemplateLiteral(['\n      padding: calc(', ' * 0.5);\n    '], ['\n      padding: calc(', ' * 0.5);\n    ']),
    _templateObject7 = _taggedTemplateLiteral(['\n      padding: ', ';\n    '], ['\n      padding: ', ';\n    ']),
    _templateObject8 = _taggedTemplateLiteral(['\n      padding: calc(', ' * 2);\n    '], ['\n      padding: calc(', ' * 2);\n    ']),
    _templateObject9 = _taggedTemplateLiteral(['\n      padding: calc(', ' * 3);\n    '], ['\n      padding: calc(', ' * 3);\n    ']),
    _templateObject10 = _taggedTemplateLiteral(['\n      padding: calc(', ' * 4);\n    '], ['\n      padding: calc(', ' * 4);\n    ']),
    _templateObject11 = _taggedTemplateLiteral(['\n      padding: calc(', ' * 5);\n    '], ['\n      padding: calc(', ' * 5);\n    ']),
    _templateObject12 = _taggedTemplateLiteral(['\n      padding-left: 0;\n      padding-right: 0;\n    '], ['\n      padding-left: 0;\n      padding-right: 0;\n    ']),
    _templateObject13 = _taggedTemplateLiteral(['\n      padding-left: calc(', ' * 0.5);\n      padding-right: calc(', ' * 0.5);\n    '], ['\n      padding-left: calc(', ' * 0.5);\n      padding-right: calc(', ' * 0.5);\n    ']),
    _templateObject14 = _taggedTemplateLiteral(['\n      padding-left: ', ';\n      padding-right: ', ';\n    '], ['\n      padding-left: ', ';\n      padding-right: ', ';\n    ']),
    _templateObject15 = _taggedTemplateLiteral(['\n      padding-left: calc(', ' * 2);\n      padding-right: calc(', ' * 2);\n    '], ['\n      padding-left: calc(', ' * 2);\n      padding-right: calc(', ' * 2);\n    ']),
    _templateObject16 = _taggedTemplateLiteral(['\n      padding-left: calc(', ' * 3);\n      padding-right: calc(', ' * 3);\n    '], ['\n      padding-left: calc(', ' * 3);\n      padding-right: calc(', ' * 3);\n    ']),
    _templateObject17 = _taggedTemplateLiteral(['\n      padding-left: calc(', ' * 4);\n      padding-right: calc(', ' * 4);\n    '], ['\n      padding-left: calc(', ' * 4);\n      padding-right: calc(', ' * 4);\n    ']),
    _templateObject18 = _taggedTemplateLiteral(['\n      padding-left: calc(', ' * 5);\n      padding-right: calc(', ' * 5);\n    '], ['\n      padding-left: calc(', ' * 5);\n      padding-right: calc(', ' * 5);\n    ']),
    _templateObject19 = _taggedTemplateLiteral(['\n      padding-top: 0;\n      padding-bottom: 0;\n    '], ['\n      padding-top: 0;\n      padding-bottom: 0;\n    ']),
    _templateObject20 = _taggedTemplateLiteral(['\n      padding-top: calc(', ' * 0.5);\n      padding-bottom: calc(', ' * 0.5);\n    '], ['\n      padding-top: calc(', ' * 0.5);\n      padding-bottom: calc(', ' * 0.5);\n    ']),
    _templateObject21 = _taggedTemplateLiteral(['\n      padding-top: ', ';\n      padding-bottom: ', ';\n    '], ['\n      padding-top: ', ';\n      padding-bottom: ', ';\n    ']),
    _templateObject22 = _taggedTemplateLiteral(['\n      padding-top: calc(', ' * 2);\n      padding-bottom: calc(', ' * 2);\n    '], ['\n      padding-top: calc(', ' * 2);\n      padding-bottom: calc(', ' * 2);\n    ']),
    _templateObject23 = _taggedTemplateLiteral(['\n      padding-top: calc(', ' * 3);\n      padding-bottom: calc(', ' * 3);\n    '], ['\n      padding-top: calc(', ' * 3);\n      padding-bottom: calc(', ' * 3);\n    ']),
    _templateObject24 = _taggedTemplateLiteral(['\n      padding-top: calc(', ' * 4);\n      padding-bottom: calc(', ' * 4);\n    '], ['\n      padding-top: calc(', ' * 4);\n      padding-bottom: calc(', ' * 4);\n    ']),
    _templateObject25 = _taggedTemplateLiteral(['\n      padding-top: calc(', ' * 5);\n      padding-bottom: calc(', ' * 5);\n    '], ['\n      padding-top: calc(', ' * 5);\n      padding-bottom: calc(', ' * 5);\n    ']);

var _styledComponents = require('styled-components');

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var dimensionModifiers = {
  display_flex: function display_flex() {
    return {
      styles: (0, _styledComponents.css)(_templateObject)
    };
  },
  height_100: function height_100() {
    return {
      styles: (0, _styledComponents.css)(_templateObject2)
    };
  },
  flex_1: function flex_1() {
    return {
      styles: (0, _styledComponents.css)(_templateObject3)
    };
  }
};

var displayModifiers = {
  noDisplay: function noDisplay() {
    return {
      styles: (0, _styledComponents.css)(_templateObject4)
    };
  }
};

var padScaleModifiers = {
  padScale_0: function padScale_0() {
    return {
      styles: (0, _styledComponents.css)(_templateObject5)
    };
  },
  padScale_half: function padScale_half(_ref) {
    var theme = _ref.theme;
    return {
      styles: (0, _styledComponents.css)(_templateObject6, theme.dimensions.gridPad)
    };
  },
  padScale_1: function padScale_1(_ref2) {
    var theme = _ref2.theme;
    return {
      styles: (0, _styledComponents.css)(_templateObject7, theme.dimensions.gridPad)
    };
  },
  padScale_2: function padScale_2(_ref3) {
    var theme = _ref3.theme;
    return {
      styles: (0, _styledComponents.css)(_templateObject8, theme.dimensions.gridPad)
    };
  },
  padScale_3: function padScale_3(_ref4) {
    var theme = _ref4.theme;
    return {
      styles: (0, _styledComponents.css)(_templateObject9, theme.dimensions.gridPad)
    };
  },
  padScale_4: function padScale_4(_ref5) {
    var theme = _ref5.theme;
    return {
      styles: (0, _styledComponents.css)(_templateObject10, theme.dimensions.gridPad)
    };
  },
  padScale_5: function padScale_5(_ref6) {
    var theme = _ref6.theme;
    return {
      styles: (0, _styledComponents.css)(_templateObject11, theme.dimensions.gridPad)
    };
  },
  padScaleX_0: function padScaleX_0() {
    return {
      styles: (0, _styledComponents.css)(_templateObject12)
    };
  },
  padScaleX_half: function padScaleX_half(_ref7) {
    var theme = _ref7.theme;
    return {
      styles: (0, _styledComponents.css)(_templateObject13, theme.dimensions.gridPad, theme.dimensions.gridPad)
    };
  },
  padScaleX_1: function padScaleX_1(_ref8) {
    var theme = _ref8.theme;
    return {
      styles: (0, _styledComponents.css)(_templateObject14, theme.dimensions.gridPad, theme.dimensions.gridPad)
    };
  },
  padScaleX_2: function padScaleX_2(_ref9) {
    var theme = _ref9.theme;
    return {
      styles: (0, _styledComponents.css)(_templateObject15, theme.dimensions.gridPad, theme.dimensions.gridPad)
    };
  },
  padScaleX_3: function padScaleX_3(_ref10) {
    var theme = _ref10.theme;
    return {
      styles: (0, _styledComponents.css)(_templateObject16, theme.dimensions.gridPad, theme.dimensions.gridPad)
    };
  },
  padScaleX_4: function padScaleX_4(_ref11) {
    var theme = _ref11.theme;
    return {
      styles: (0, _styledComponents.css)(_templateObject17, theme.dimensions.gridPad, theme.dimensions.gridPad)
    };
  },
  padScaleX_5: function padScaleX_5(_ref12) {
    var theme = _ref12.theme;
    return {
      styles: (0, _styledComponents.css)(_templateObject18, theme.dimensions.gridPad, theme.dimensions.gridPad)
    };
  },
  padScaleY_0: function padScaleY_0() {
    return {
      styles: (0, _styledComponents.css)(_templateObject19)
    };
  },
  padScaleY_half: function padScaleY_half(_ref13) {
    var theme = _ref13.theme;
    return {
      styles: (0, _styledComponents.css)(_templateObject20, theme.dimensions.gridPad, theme.dimensions.gridPad)
    };
  },
  padScaleY_1: function padScaleY_1(_ref14) {
    var theme = _ref14.theme;
    return {
      styles: (0, _styledComponents.css)(_templateObject21, theme.dimensions.gridPad, theme.dimensions.gridPad)
    };
  },
  padScaleY_2: function padScaleY_2(_ref15) {
    var theme = _ref15.theme;
    return {
      styles: (0, _styledComponents.css)(_templateObject22, theme.dimensions.gridPad, theme.dimensions.gridPad)
    };
  },
  padScaleY_3: function padScaleY_3(_ref16) {
    var theme = _ref16.theme;
    return {
      styles: (0, _styledComponents.css)(_templateObject23, theme.dimensions.gridPad, theme.dimensions.gridPad)
    };
  },
  padScaleY_4: function padScaleY_4(_ref17) {
    var theme = _ref17.theme;
    return {
      styles: (0, _styledComponents.css)(_templateObject24, theme.dimensions.gridPad, theme.dimensions.gridPad)
    };
  },
  padScaleY_5: function padScaleY_5(_ref18) {
    var theme = _ref18.theme;
    return {
      styles: (0, _styledComponents.css)(_templateObject25, theme.dimensions.gridPad, theme.dimensions.gridPad)
    };
  }
};

exports.dimensionModifiers = dimensionModifiers;
exports.displayModifiers = displayModifiers;
exports.padScaleModifiers = padScaleModifiers;


//////////////////
// WEBPACK FOOTER
// ./node_modules/styled-components-reactive-grid/dist/utils/modifiers.js
// module id = 436
// module chunks = 2